import React, { useEffect, useState } from 'react';
import './styles/GestionarPermisosModal.css';

const GestionarPermisosModal = ({
  open,
  loading,
  permisos,
  permisosAsignados,
  onClose,
  onSave
}) => {
  const [seleccionados, setSeleccionados] = useState([]);

  useEffect(() => {
    // Normaliza los IDs a string para coincidencia exacta
    setSeleccionados((permisosAsignados || []).map(String));
  }, [permisosAsignados, open]);

  const handleToggle = id => {
    const idStr = String(id);
    setSeleccionados(prev =>
      prev.includes(idStr)
        ? prev.filter(pid => pid !== idStr)
        : [...prev, idStr]
    );
  };

  const handleGuardar = () => {
    if (onSave) onSave(seleccionados, () => {});
  };

  if (!open) return null;

  return (
    <div className="modal-permisos-backdrop">
      <div className="modal-permisos-container">
        <h3 className="modal-permisos-title">Gestionar Permisos del Rol</h3>
        {loading ? (
          <div className="modal-permisos-loading">Cargando permisos...</div>
        ) : (
          <div className="modal-permisos-list">
            {permisos.map((permiso, idx) => {
              const idStr = String(permiso.id_permiso ?? permiso.id_permisos);
              return (
                <div className="modal-permisos-item" key={idStr ?? `permiso-${idx}`}>
                  <label>
                    <input
                      type="checkbox"
                      checked={seleccionados.includes(idStr)}
                      onChange={() => handleToggle(idStr)}
                      className="modal-permisos-checkbox"
                    />
                    <span className="modal-permisos-nombre">{permiso.nombre}</span>
                    <span className="modal-permisos-desc">({permiso.descripcion})</span>
                  </label>
                </div>
              );
            })}
          </div>
        )}
        <div className="modal-permisos-actions">
          <button onClick={onClose} className="modal-permisos-btn cancelar" type="button">
            Cancelar
          </button>
          <button onClick={handleGuardar} disabled={loading} className="modal-permisos-btn guardar" type="button">
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
};

export default GestionarPermisosModal;
